// extracted by mini-css-extract-plugin
export var slickWrapper = "styles-module--slickWrapper--4x-sx";
export var logo = "styles-module--logo--1ZRCz";
export var numberSlide = "styles-module--numberSlide--1npLv";
export var fourOuFour = "styles-module--fourOuFour--2V6vh";